import React, { useContext } from 'react'
import { renderFullAddress, renderDateTime } from "../utils";
import useEventActions from "../hooks/useEventActions"
import { AuthContext, LanguageContext } from "../context"
import { Link } from "react-router-dom"

export default function EventListItem({ event, eventIndex, handleShare }) {
  const { isEventOrganiser, isEventDriver, myEventVehicle, isVehiclePassenger, myVehiclePassengers, vehiclePassengers, isOnWaitlist, isEventParticipant, myWaitlistPassengers } = useEventActions({})
  const { authUser } = useContext(AuthContext)
  const { t } = useContext(LanguageContext)
  const eventRoles = (event) => {
    const roles = []
    if (isEventOrganiser(event)) {
      roles.push('organiser')
    }
    if (isEventDriver(event)) {
      roles.push('driver')
    }
    if (isVehiclePassenger(-1, '', event)) {
      roles.push('passenger')
    }
    if (isOnWaitlist(event)) {
      roles.push('waitlist')
    }
    return roles
  }

  const eventIcon = (event) => {
    if (!authUser) {
      return ""
    }
    if (isEventOrganiser(event)) {
      return '/event.svg';
    } else if (isEventDriver(event)) {
      return '/Driver.svg';
    } else if (isVehiclePassenger(-1, '', event)) {
      return '/passenger.svg';
    } else if (isOnWaitlist(event)) {
      return '/waiting list.svg';
    }
    return '/event.svg';
  }

  const iconForRole = (role) => {
    switch (role) {
      case 'organiser':
        return '/event.svg'
      case 'driver':
        return '/Driver.svg'
      case 'passenger':
        return '/passenger.svg'
      case 'waitlist':
        return '/waitlist.svg'
      default:
        return ''
    }
  }

  const labelForRole = (role, event) => {
    switch (role) {
      case 'organiser':
        return t('my_events.organiser_label')
      case 'driver':
        const vehicle = myEventVehicle(event)
        const passengersTrip1 = vehiclePassengers(vehicle, 'trip1')
        const passengersTrip2 = vehiclePassengers(vehicle, 'trip2')
        let label = t('my_events.driver_label')
        const vehicleTripsLabel =
          vehicle.trip1?.available && vehicle.trip2?.available ? `(${t('generic.trip1')} & ${t('generic.trip2')})`
            : vehicle.trip1?.available ? `(${t('generic.trip1')})`
            : vehicle.trip2?.available ? `(${t('generic.trip2')})`
            : ''
        label += ` ${vehicleTripsLabel}`
        if (passengersTrip1 && passengersTrip1.length) {
          label += `\n${t('my_events.my_event_passengers_trip1', { passengers: passengersTrip1.map(p => p.firstname).join(', ') })}`
        }
        if (passengersTrip2 && passengersTrip2.length) {
          label += `\n${t('my_events.my_event_passengers_trip2', { passengers: passengersTrip2.map(p => p.firstname).join(', ') })}`
        }
        return label
      case 'passenger':
        const myPassengers = myVehiclePassengers(-1, '', event)
        const myPassengersTrip1 = myPassengers.filter(p => p.trip1)
        const myPassengersTrip2 = myPassengers.filter(p => p.trip2)
        let passengerNames = ''
        if (myPassengersTrip1.length) {
          passengerNames += `${myPassengersTrip1.map(p => p.firstname).join(', ')} (${t('generic.trip1')})`
        }
        if (myPassengersTrip2.length) {
          passengerNames += `${passengerNames ? ', ' : ''}${myPassengersTrip2.map(p => p.firstname).join(', ')} (${t('generic.trip2')})`
        }
        return t('my_events.my_event_passengers', { passengers: passengerNames })
      case 'waitlist':
        const waitlistPassengers = myWaitlistPassengers(event)
        const waitlistPassengersTrip1 = waitlistPassengers.filter(p => p.trip1)
        const waitlistPassengersTrip2 = waitlistPassengers.filter(p => p.trip2)
        let waitlistNames = ''
        if (waitlistPassengersTrip1.length) {
          waitlistNames += `${waitlistPassengersTrip1.map(p => p.firstname).join(', ')} (${t('generic.trip1')})`
        }
        if (waitlistPassengersTrip2.length) {
          waitlistNames += `${waitlistNames ? ', ' : ''}${waitlistPassengersTrip2.map(p => p.firstname).join(', ')} (${t('generic.trip2')})`
        }
        return t('my_events.waitlist_label_passengers', { passengers: waitlistNames })
      default:
        return ''
    }
  }

  return (
    <>
      <div className="flex flex-col lg:flex-row justify-between mb-6">
        <div className="w-full">
          <h4 className="event-title mb-3 lg:mb-0">
            {event.title}
          </h4>
          <h4 className="event-address mb-3 lg:mb-0">
            <span>{t('my_events.start')}:</span>   {renderDateTime(event?.start)} <br />
            <span>{t('my_events.end')}:</span> {renderDateTime(event?.end)} <br />
            <span>{t('my_events.address')}:</span> {renderFullAddress(event.address)}<br />
          </h4>

        </div>
        <div className="lg:w-5/12 gap-4 flex lg:justify-end items-center">
          <Link to={`/event/${event.id}`} className="">
            <button className="light">
              <img src="/visibility.svg" />
              {t('generic.view')}
            </button>
          </Link>
          {isEventOrganiser(event) &&
            <button className="light" onClick={() => handleShare(event)}>
              <img src="/send.svg" />
              {t('generic.share')}
            </button>
          }
        </div>
      </div>
      <div className="flex flex-col">
        {eventRoles(event).map((role, roleIndex) => (
          <div className="bg-white py-4 px-8 text-start flex items-center gap-6 rounded-lg" key={`event_${eventIndex}_role_${roleIndex}`}>
            <img src={iconForRole(role)} className="w-12" />
            <span className="whitespace-pre-wrap">{labelForRole(role, event)}</span>
          </div>
        ))}
      </div>
    </>
  )
}
